import CitiesList from './CitiesList';

export default CitiesList;
